var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"mapContainer",staticClass:"pa-0",style:(`height: 100%`)},[_c('div',{ref:_vm.mapRef,staticClass:"rounded-lg mapContainer",staticStyle:{"width":"100%","height":"100%"}})])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }